import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Restaurant nou',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Demo nou',
        [CompanyCreationModes.full]: 'Restaurant nou',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Info restaurant',
        [CompanyCreationSteps.BusinessInfo]: 'Info companie',
        [CompanyCreationSteps.AdditionalLocations]: 'Restaurante suplimentare',
      },
    },
    business_profile: {
      legal_info: 'Info juridice',
      owner_info: 'Info proprietar',
    },
    recently_created: 'Create recent',
  },
  form: {
    franchise: {
      label: 'Creează restaurant',
      tooltip:
        'Selectați dacă creați un brand complet nou sau adăugați acest restaurant la un brand existent în sistemul nostru.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Creează un brand nou',
          tooltip: 'Pornim de la zero — fără brand sau restaurant existent',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Adaugă acest restaurant la un brand existent',
          tooltip: 'Aparține deja unui brand din sistem',
        },
      },
    },
    restaurants: {
      label: 'Restaurant(e) asociat(e)',
    },

    business_profile: {
      label: 'Cine este proprietarul?',
      tooltip:
        'Acest restaurant aparține unui proprietar/companie deja existent(ă) în sistemul nostru (ex. „Luís Pizza GmbH")? <br/> Dacă da, selectați profilul existent. În caz contrar, creați unul nou.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Creează profil nou de proprietar/companie',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Folosește profil existent de proprietar/companie',
      },
    },
    business_type: {
      label: 'Tip de afacere',
      placeholder: 'Selectați tipul de afacere',
      options: {
        [BusinessType.Company]: 'Companie',
        [BusinessType.Individual]: 'Persoană fizică autorizată',
      },
    },
    display_name: {
      label: 'Nume restaurant',
      placeholder: 'Nume prietenos',
    },
    legal_name: {
      label: 'Nume legal',
      placeholder: 'Nume legal',
    },
    owner_first_name: {
      label: 'Prenumele persoanei de contact',
      placeholder: 'Ion',
    },
    owner_last_name: {
      label: 'Numele persoanei de contact',
      placeholder: 'Popescu',
    },
    owner_phone_number: {
      label: 'Telefonul persoanei de contact',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mailul persoanei de contact',
      placeholder: 'Introduceți e-mailul',
    },
    password: {
      label: 'Parolă',
      placeholder: 'Introduceți parola',
    },

    additional_companies: {
      label: 'Restaurante suplimentare sub același brand',
      tooltip:
        'Există restaurante suplimentare sub același brand ca {{company}}? <br/> Dacă da, faceți clic pe „Adaugă restaurant" pentru a include mai multe locații. Dacă același proprietar are un brand diferit, nu adăugați aici — creați-l separat.',
    },
  },
  labels: {
    create_demo: 'Creează demo',
    create_company: 'Creează restaurant',
    business_type: 'Tip de afacere',
    display_name: 'Nume prietenos',
    legal_name: 'Nume legal',
    owner_name: 'Nume proprietar',
    address: 'Adresă',
  },
  fields: {
    name: 'Nume',
    created_at: 'Creat',
    actions: 'Acțiuni',
  },

  buttons: {
    add_restaurant: '+ Adaugă restaurant',
    continue: 'Continuă',
    back: 'Înapoi',
    create: 'Creează restaurant',
    delete: 'Șterge',
  },
  popups: {
    delete_demo: {
      title: 'Sigur doriți să ștergeți?',
    },
  },
  toasts: {
    company_created: 'Restaurantul a fost creat cu succes',
    failed_to_create_company: 'Eroare la crearea restaurantului',
    failed_to_delete_demo: 'Eroare la ștergerea demo-ului',
    demo_got_deleted: 'Demo șters cu succes',
    failed_to_load_recently_created_companies: 'Eroare la încărcarea restaurantelor create recent',
  },
};
